import React, { useState, useEffect } from "react"
import { FaAngleDoubleUp } from "react-icons/all"

const BackToTop = () => {
  const [reveal, setReveal] = useState(false)
  const [lastYPos, setLastYPos] = useState(0)

  useEffect(() => {
    function handleScroll() {
      const yPos = window.scrollY
      const isScrollingUp = yPos < lastYPos
      if (yPos > 900) {
        setReveal(isScrollingUp)
      } else {
        setReveal(false)
      }
      setLastYPos(yPos)
    }
    window.addEventListener("scroll", handleScroll, false)
    return () => {
      window.removeEventListener("scroll", handleScroll, false)
    }
  }, [lastYPos])

  const backToTop = () => {
    window.scrollTo(0, 0)
  }

  return (
    <div
      className={reveal ? "revealed back-to-top" : "back-to-top"}
      onClick={backToTop}
    >
      <FaAngleDoubleUp className="icon" />
    </div>
  )
}

export default BackToTop
